<hpf-image-form
	[image]="image"
	[loading]="image.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-image-form>
<div class="container">
	<hpf-activity-history
		*ngIf="historySearchParams"
		[historySearchParams]="historySearchParams"
	></hpf-activity-history>
</div>
